import { useCallback, useRef } from 'react';

export const useCanvasRenderer = (
  canvasRef: React.RefObject<HTMLCanvasElement | null>,
) => {
  const canvasCtxRef = useRef<CanvasRenderingContext2D | null>(null);
  const lastCanvasRef = useRef<HTMLCanvasElement | null>(null);

  const drawFrame = useCallback(
    (frame: VideoFrame) => {
      const canvas = canvasRef.current;
      if (!canvas) {
        frame.close();
        return;
      }

      if (lastCanvasRef.current !== canvas || !canvasCtxRef.current) {
        lastCanvasRef.current = canvas;
        canvasCtxRef.current = canvas.getContext('2d');
      }

      const canvasCtx = canvasCtxRef.current;
      if (canvasCtx) {
        // Resize canvas to match frame dimensions if needed
        if (
          canvas.width !== frame.displayWidth ||
          canvas.height !== frame.displayHeight
        ) {
          canvas.width = frame.displayWidth;
          canvas.height = frame.displayHeight;
        }
        canvasCtx.drawImage(frame, 0, 0);
      }
      frame.close();
    },
    [canvasRef],
  );

  const setCanvasSize = useCallback(
    (width: number, height: number) => {
      const canvas = canvasRef.current;
      if (canvas) {
        canvas.width = width;
        canvas.height = height;
      }
    },
    [canvasRef],
  );

  return {
    drawFrame,
    setCanvasSize,
  };
};
